import { AuthRepositoryImpl } from '../Data/AuthRepositoryImpl';
import { CheckEmailUseCase } from '../Domain/usecases/CheckEmailUseCase';
import { SignInUseCase } from '../Domain/usecases/SignInUseCase';
import { SignUpUseCase } from '../Domain/usecases/SignUpUseCase';
import { SnsLinkUseCase } from '../Domain/usecases/SnsLinkUseCase';
import { SnsSelectUseCase } from '../Domain/usecases/SnsSelectUseCase';
import { SnsSignInUseCase } from '../Domain/usecases/SnsSignInUseCase';
import { SnsSignUpUseCase } from '../Domain/usecases/SnsSignUpUseCase';

const repository = new AuthRepositoryImpl();

export const authUseCases = {
  signIn: new SignInUseCase(repository),
  signUp: new SignUpUseCase(repository),
  checkEmail: new CheckEmailUseCase(repository),
  snsSignIn: new SnsSignInUseCase(repository),
  snsSelect: new SnsSelectUseCase(repository),
  snsLink: new SnsLinkUseCase(repository),
  snsSignUp: new SnsSignUpUseCase(repository),
};
